<template>
  <div class="modal fade" ref="modal" tabindex="-1" aria-labelledby="confirmAction" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{title | translate}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          
        </button>
      </div>
      <div class="modal-body">
        {{text | translate}}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{'Cancel' | translate}}</button>
        <button type="button" class="btn btn-primary" @click="handleConfirm">{{cta | translate}}</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import _ from 'lodash'

export default {
  data(){return {
    title: 'Are you sure?',
    text: 'It will be not be possible to recover the content',
    cta: 'Confirm',
    payload: null,
    action: null,
  }},
  mounted() {
    this.confirmModal = new bootstrap.Modal(this.$refs.modal, {})
  },
  methods: {
    cleanup() {
      this.title = 'Are you sure?'
      this.text = 'It will be not be possible to recover the content'
      this.cta = 'Confirm' 
      this.payload = null
      this.action = null
    },
    modal({title, text, action, payload, cta}){
      if (title) {
        this.title = title
      }
      if (text) {
        this.text = text
      }
      if (cta) {
        this.cta = cta
      }
      if (_.isUndefined(action)) {
        throw new Error('action is required')
      }
      if (_.isUndefined(payload)) {
        throw new Error('payload is required')
      }
      this.action = action
      this.payload = payload

      this.show()
    },
    show() {
      this.confirmModal.show()
    },
    hide() {
      this.confirmModal.hide()
    },
    handleConfirm() {
      this.hide()
      this.action(this.payload)
      this.cleanup()
      // this.$emit('confirm', {
      //   action: this.action,
      //   payload: this.payload,
      // })
    },
  },
}
</script>
